package pwgs.ui.scenes.projectlist

import visage.core.Navigation


class ProjectListControllerFe(props: ProjectListSceneProps, scene: MProjectListScene) : AProjectListControllerFe(props, scene) {

    override fun createInitialModel() : ProjectListSceneModel {
        return ProjectListSceneModel(listOf())
    }

    override fun init() {
        call_load()
    }

    fun onProjectClicked(id: Long) {
        Navigation.pushLocation("/app/project/$id/index.vsg")
    }

    fun onCreateProjectButtonClicked() {
        model.createProjectDialogModel = CreateProjectDialogModel()
        this.render(this.model)
    }

    fun onCancelCreateNewProjectclicked() {
        model.createProjectDialogModel = null
        this.render(model)
    }

    fun createProject() {
        this.model.createProjectDialogModel!!.error = ""
        this.model.createProjectDialogModel!!.isLoading = true
        this.render(this.model)

        call_createProject()
    }


}

